import React, { ForwardRefRenderFunction, Suspense, useEffect } from 'react'

import { getLazyComponent } from './get-lazy-component'
import {
  PageComponentProps,
  RegisterPageOptions,
  ShouldPageRenderHook,
  ShouldRenderRef,
} from './types'

import { FullscreenSpinnerPage } from '@/components/shared/FullscreenSpinner'

export function createPageComponent(
  useShouldRender: ShouldPageRenderHook,
  options: RegisterPageOptions,
): ForwardRefRenderFunction<ShouldRenderRef, PageComponentProps> {
  const Component = getLazyComponent(options.pageFactory)

  return function PageComponent({ appProps, isOptional = false }, ref) {
    const shouldRender = useShouldRender(isOptional)

    useEffect(() => {
      if (ref && 'current' in ref)
        ref.current?.onShouldRenderChange?.(shouldRender)
    }, [ref, shouldRender])

    return (
      <>
        {shouldRender ? (
          <Suspense fallback={<FullscreenSpinnerPage />}>
            <Component {...(appProps as JSX.IntrinsicAttributes)} />
          </Suspense>
        ) : (
          <FullscreenSpinnerPage />
        )}
      </>
    )
  }
}
